import React from "react";
import { useTranslation } from "react-i18next";

const Steps = ({ activeStep }) => {
    const { t } = useTranslation();
  
  const steps = [
    { id: 1, label: t("SelectShip") },
    { id: 2, label: t("ChooseAddress") },
    { id: 3, label:  t("OrderSummary")},
  ];

  return (
    <div className="flex items-center justify-between gap-6 p-6 bg-yellow-50">
      {steps.map((step) => (
        <div key={step.id} className="flex flex-col items-center justify-center">
          <div
            className={`flex items-center justify-center w-12 h-12 lg:w-16 lg:h-16 border-2 ${
              activeStep === step.id
                ? "bg-yellow-400 text-white border-yellow-400"
                : "bg-white text-black border-gray-300"
            }`}
          >
            <span className="text-lg font-bold text-black">{step.id}</span>
          </div>
          <p className="mt-1 text-xs font-bold text-center text-black lg:text-base">{step.label}</p>
        </div>
      ))}
    </div>
  );
};

export default Steps;
